define.alias("ember-cli-string-helpers/helpers/truncate", "settings/helpers/truncate");